<div class="col-sm-12">
	<div class="form-field margin-bottom-lg">
		<label for="name">Customer Name</label>
		<input required type='text' class='form-control' [(ngModel)]='customer.name' (ngModelChange)="onInputChange()" placeholder='Customer Name' name="name" />
		<div *ngIf="notValidCustomerName && !showDuplicateAlert && customer?.name?.length > 0" class="text-danger">
			Customer already exists
		</div>
	</div>

	<!-- Duplicate Customer Detection Alert -->
	<div *ngIf="showDuplicateAlert && similarCustomers.length > 0"
		style="padding: 10px 15px; margin-bottom: 15px; border: 1px solid #f5c6cb; background-color: #f8d7da; color: #721c24;">
		<strong style="display: block; margin-bottom: 8px;">Duplicate Customer Detected</strong>
		<div class="form-group" style="margin-bottom: 8px;">
			<label style="font-weight: bold; margin-bottom: 3px; display: block; font-size: 12px;">Similar Customers:</label>
			<ul style="margin: 0 0 8px 0; padding-left: 20px; font-size: 12px;">
				<li *ngFor="let match of similarCustomers" style="margin-bottom: 3px;">
					{{ match.name }}
					<span style="color: #999;">({{ match.matchType === 'name_exact' ? 'Exact Match' : 'Similarity: ' + match.similarity + '%' }})</span>
				</li>
			</ul>
		</div>
		<div style="margin-bottom: 8px; display: flex; gap: 8px; flex-wrap: wrap;">
			<button type="button" class="btn btn-sm btn-warning" (click)="overrideClick()">Create Anyway (Override)</button>
		</div>
		<p style="margin-bottom: 0; font-size: 12px; color: #666;">A customer with a similar name already exists. Please verify this is not a duplicate before proceeding.</p>
	</div>

	<fieldset>
		<legend>Contact Info</legend>
		<div class="form-field margin-bottom-sm">
			<label for="name">Name</label>
			<input type='text' class='form-control' name="contactname" [(ngModel)]='customer.contactname' placeholder='Person Name' />
		</div>

		<div class="form-field margin-bottom-sm">
			<label for='phoneno'>Phone No.</label>
			<input type='text' class='form-control' name="phoneno" [(ngModel)]='customer.phoneno' placeholder='Phone No.' />
		</div>
	</fieldset>
</div>
